import React from "react";
import maraLogo from "../assets/mara-logo@2x.png";
import "./MaraFooter.css";

/**
 * MaraFooter — firma di autoria "MARA × ENERLEFT".
 *
 * Varianti:
 *   - default : trasparente, eredita bg del contesto (usato da AuthShell su graphite).
 *   - "dark"  : fascia dark #181B20 edge-to-edge con border-top sottile
 *               (usato da AppShell + PortalShell su content chiaro per leggibilità
 *               del logo chrome).
 */
export default function MaraFooter({ variant = "default" }) {
    const cls =
        variant === "dark"
            ? "mara-footer mara-footer--dark"
            : "mara-footer";
    return (
        <footer className={cls} data-testid="mara-footer" data-variant={variant}>
            <a
                href="https://www.designermara.it"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Designed by Mara"
                className="mara-footer__link"
                data-testid="mara-footer-link"
            >
                <img
                    src={maraLogo}
                    alt=""
                    className="mara-footer__logo"
                    aria-hidden
                />
                <span className="mara-footer__suffix">
                    <span className="mara-footer__sep" aria-hidden>×</span>
                    <span className="mara-footer__brand">ENERLEFT</span>
                </span>
            </a>
        </footer>
    );
}
